import styled from '@emotion/styled';
import {colors, fontSize, sizes} from 'patient-ping-remedy/packages/theme';
import {StandardTypography} from 'patient-ping-remedy/packages/typography';

export const NoElementsWrapper = styled.div<{ center?: boolean }>`
  padding: ${sizes.medium};
  font-style: italic;
  text-align: ${({ center }) => center ? 'center' : 'initial'};
`;

export const MarkAllAsRead = styled.button`
  color: ${colors.blue4};
  padding: 0;
  background: none;
  border: none;
  cursor: pointer;

  &:disabled {
    cursor: not-allowed;
    color: ${colors.gray4};
  }
`;

export const ElementGroup = styled.div`
  margin-top: 1.5rem;
  margin-bottom: ${sizes.xSmall};
`;

export const TimeCategoryHeaderWrapper = styled('div')`
  align-items: center;
  display: flex;
  justify-content: space-between;
`;

export const TimeCategoryHeader = styled(StandardTypography)`
  color: ${colors.gray4};
  font-size: ${fontSize.heading};
  text-transform: uppercase;
`;
